import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  static isNotEmpty(control: AbstractControl): any {
    const value = control.value;
    if (value.trim() === '') {
      return { required: { message: 'Field is required' } };
    }
    return null;
  }

  static isValidCharacters(control: AbstractControl): any {
    const value = control.value;
    if (!/^[a-zA-Z0-9@.!#$%&'*+/=?^_`’|-\s]*$/.test(value)) {
      return { invalidCharacters: { message: 'Contains invalid characters' } };
    }
    return null;
  }

  static isEmailFormatValid(control: AbstractControl): any {
    const value = control.value;
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
      return { invalidEmailFormat: { message: 'Email format is not valid' } };
    }
    return null;
  }

  static containsSymbolOrNumber(control: AbstractControl): any {
    const value = control.value;
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/.test(value)) {
      return { missingSymbolOrNumber: { message: 'Should contain a symbol or a number' } };
    }
    return null;
  }

  static containsSpace(control: AbstractControl): any {
    const value = control.value;
    if (/\s/.test(value)) {
      return { containsSpace: { message: 'Cannot contain spaces' } };
    }
    return null;
  }

  static isLettersOnly(control: AbstractControl): any {
    const value = control.value;
    if (!/^[a-zA-Z]*$/.test(value)) {
      return { lettersOnly: { message: 'Only letters are allowed' } };
    }
    return null;
  }

  static isNumbersOnly(control: AbstractControl): any {
    const value = control.value;
    if (!/^[0-9]*$/.test(value)) {
      return { numbersOnly: { message: 'Only numbers are allowed' } };
    }
    return null;
  }
  static isMinLength(control: AbstractControl, minLength: number): any {
    const value = control.value;
    if (value.length < minLength) {
      return { minLength: { requiredLength: minLength, message: 'Minimum length is ${minLength} characters' } };
    }
    return null;
  }

  static isMaxLength(control: AbstractControl, maxLength: number): any {
    const value = control.value;
    if (value.length > maxLength) {
      return { maxLength: { requiredLength: maxLength, message: 'Maximum length is ${maxLength} characters' } };
    }
    return null;
  }
  static mustBeTrue(control: AbstractControl): any {
    const value = control.value;
    if (value != true) {
      return { mustBeTrue: true, message: 'Checkbox is required' };
    }
    return null;
  }

  static isUkPostcodeFormat(control: AbstractControl): ValidationErrors | null {
    const postcodeRegex = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i;
    const value = control.value;
    if (!postcodeRegex.test(value)) {
      return { notPostcodeFormat: { message: 'Invalid postcode' } };
    }
    return null;
  }

  static validateEmail(control: AbstractControl): any {
    return (
      ValidationService.isNotEmpty(control) ||
      ValidationService.containsSpace(control) ||
      ValidationService.isValidCharacters(control) ||
      ValidationService.isMaxLength(control, 100) ||
      ValidationService.isEmailFormatValid(control)
    );
  }

  static validatePassword(control: AbstractControl): any {
    return (
      ValidationService.isNotEmpty(control) ||
      ValidationService.containsSpace(control) ||
      ValidationService.isValidCharacters(control) ||
      ValidationService.isMinLength(control, 8) ||
      ValidationService.isMaxLength(control, 100) ||
      ValidationService.containsSymbolOrNumber(control)
    );
  }

  static validateLoginPassword(control: AbstractControl): any {
    return (
      ValidationService.isNotEmpty(control) ||
      ValidationService.containsSpace(control) ||
      ValidationService.isValidCharacters(control) ||
      ValidationService.isMaxLength(control, 100)
    );
  }

  static validateNames(control: AbstractControl): any {
    return (
      ValidationService.isNotEmpty(control) ||
      ValidationService.isValidCharacters(control) ||
      ValidationService.isMinLength(control, 1) ||
      ValidationService.isMaxLength(control, 100)
    );

    //|| ValidationService.isLettersOnly(control)
  }

  static validatePhone(control: AbstractControl): any {
    return (
      ValidationService.isNotEmpty(control) ||
      ValidationService.isValidCharacters(control) ||
      ValidationService.isNumbersOnly(control) ||
      ValidationService.isMinLength(control, 5) ||
      ValidationService.isMaxLength(control, 20)
    );
  }

  static validatePostCode(control: AbstractControl): any {
    return (
      ValidationService.isNotEmpty(control) ||
      ValidationService.isValidCharacters(control) ||
      ValidationService.isMinLength(control, 2) ||
      ValidationService.isMaxLength(control, 100)
    );
  }

  static isValidZipCodeFormat(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!/^\d{5}(-\d{4})?$/.test(value)) {
      return { invalidZipCode: { message: 'Invalid zip code' } };
    }
    return null;
  }

  static validateZipCode(control: AbstractControl): ValidationErrors | null {
    return ValidationService.isNotEmpty(control) || ValidationService.isValidZipCodeFormat(control);
  }

  static maxWeightValidator(maxValue: number, errorMessage: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === '') {
        return null;
      }
      if (Validators.required(control) !== null || isNaN(value) || value > maxValue) {
        return { maxWeight: { message: errorMessage } };
      }
      return null;
    };
  }

  static minWeightValidator(minValue: number = 100): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === '') {
        return null;
      }
      if (Validators.required(control) !== null || isNaN(value) || value < minValue) {
        return { minWeight: { message: 'Minimum weight for cats and dogs is 0.1kgs/0.22lbs' } };
      }
      return null;
    };
  }
}
